import type { LilliSettings } from "@/getSettings";

export default {
  // NOTE: privacy policy and tos may contain a string $langcode which will be replaced with the currently set language code of the user
  termsAndConditionsLink: "/policies/Nutzungsbedingungen_WhatzLearn_03-25.pdf",
  privacyPolicyLink: "/policies/Datenschutzhinweis_WhatzLearn_03-25.pdf",
  headerlogo: "/img/logo.png",
  showDetailsForQuiz: false,
  showDetailsForSurvey: false,
  showSeal: true,
  showCovidView: false,
  showCovidCertificatesToAdmin: false,
  showTestCenterView: true,
  title: "whatzlearn",
  registrationRequiredDetails: {
    phone: { request: false, mandatory: false },
    address: { request: false, mandatory: false },
    lastname: { request: true, mandatory: true },
    firstname: { request: true, mandatory: true },
    birthday: { request: false, mandatory: false },
    birthyear: { request: false, mandatory: false },
    company: { request: false, mandatory: false },
  },
  qGateFields: [
    { id: "birthdate", type: "date", label: "birthday", mandatory: true },
    { id: "birthplace", type: "string", label: "birthplace", mandatory: true },
    // NOTE: nationalityWithNonEuVisa also adds the additional, optional fields socialSecurity and workPermit (if the user is not from the EU)
    {
      id: "nationality",
      type: "nationalityWithNonEuVisa",
      label: "nationality",
      mandatory: true,
    },
    { id: "address", type: "string", label: "address", mandatory: true },
    { id: "city", type: "string", label: "city", mandatory: true },
    { id: "zipCode", type: "string", label: "zipCode", mandatory: true },
    { id: "country", type: "country", label: "country", mandatory: true },
    {
      id: "car",
      type: "switchString",
      label: "car",
      mandatory: false,
      settings: { subLabel: "carPlate", subId: "carPlate" },
    },
  ],
  emailAsUsername: true,
  supportedLanguages: [
    "de",
    "en",
    "bg",
    "cs",
    "el",
    "hr",
    "hu",
    "it",
    "lv",
    "pl",
    "pt",
    "ru",
    "ro",
    "es",
    "tr",
  ],
} satisfies LilliSettings;
